import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Toolbar, IconButton, OutlinedInput, InputAdornment, Popover, FormControl, Avatar, InputLabel, Select, MenuItem, Typography, Tooltip, FormGroup, FormControlLabel, Checkbox, Badge, ListItemButton, ListItemText,
} from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';

// import MapIcon from '@mui/icons-material/Map';
import ViewListIcon from '@mui/icons-material/ViewList';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import TuneIcon from '@mui/icons-material/Tune';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { useTranslation } from '../common/components/LocalizationProvider';
import { useDeviceReadonly } from '../common/util/permissions';
// import { formatBoolean } from '../common/util/formatter';
import DeviceRow from './DeviceRow';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: 'flex',
    gap: theme.spacing(1),
    cursor: 'default',
  },
  filterPanel: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    width: theme.dimensions.drawerWidthTablet,
  },
}));
// editado
const MainToolbar = ({
  filteredDevices,
  devicesOpen,
  setDevicesOpen,
  keyword,
  setKeyword,
  // data,
  // index,
  filter,
  setFilter,
  filterSort,
  setFilterSort,
  filterMap,
  setFilterMap,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const t = useTranslation();

  const deviceReadonly = useDeviceReadonly();

  const groups = useSelector((state) => state.groups.items);
  const devices = useSelector((state) => state.devices.items);

  // const item = data[index];
  // const position = useSelector((state) => state.attributes.positions[item.id]);

  const toolbarRef = useRef();
  const inputRef = useRef();
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [devicesAnchorEl, setDevicesAnchorEl] = useState(null);

  const deviceStatusCount = (status) => Object.values(devices).filter((d) => d.status === status).length;

  // const deviceMotionCount = (motionstate) => Object.values(devices).filter((d) => d.motionstate === motionstate).length;

  // const deviceMotion = (attributes) => Object.values(position).filter((d) => d.attributes === attributes).length;

  const somaStatus = deviceStatusCount('offline') + deviceStatusCount('unknown') + deviceStatusCount('online');

  return (
    <Toolbar ref={toolbarRef} className={classes.toolbar}>
      <IconButton edge="start" onClick={() => setDevicesOpen(!devicesOpen)}>
        {devicesOpen ? <FormatListBulletedIcon /> : <ViewListIcon />}
      </IconButton>
      <Tooltip title="Adicionar Dispositivo" arrow>
        <IconButton edge="start" onClick={() => navigate('/settings/device')} disabled={deviceReadonly}>
          <AddCircleIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Adicionar Usuário" arrow>
        <IconButton edge="start" onClick={() => navigate('/settings/user')} disabled={deviceReadonly}>
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>
      <OutlinedInput
        ref={inputRef}
        placeholder={t('sharedSearchDevices')}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onFocus={() => setDevicesAnchorEl(toolbarRef.current)}
        onBlur={() => setDevicesAnchorEl(null)}
        endAdornment={(
          <InputAdornment position="end">
            <IconButton size="small" edge="end" onClick={() => setFilterAnchorEl(inputRef.current)}>
              <Badge color="info" variant="dot" invisible={!filter.statuses.length && !filter.groups.length}>
                <TuneIcon fontSize="small" />
              </Badge>
            </IconButton>
          </InputAdornment>
        )}
        size="small"
        fullWidth
      />
      <Popover
        open={!!devicesAnchorEl && !devicesOpen}
        anchorEl={devicesAnchorEl}
        onClose={() => setDevicesAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: Number(theme.spacing(2).slice(0, -2)),
        }}
        marginThreshold={0}
        PaperProps={{
          style: { width: `calc(${toolbarRef.current?.clientWidth}px - ${theme.spacing(4)})` },
        }}
        elevation={1}
        disableAutoFocus
        disableEnforceFocus
      >
        {filteredDevices.slice(0, 3).map((_, index) => (
          <DeviceRow key={filteredDevices[index].id} data={filteredDevices} index={index} />
        ))}
        {filteredDevices.length > 3 && (
          <ListItemButton alignItems="center" onClick={() => setDevicesOpen(true)}>
            <ListItemText
              primary={t('notificationAlways')}
              style={{ textAlign: 'center' }}
            />
          </ListItemButton>
        )}
      </Popover>
      <Popover
        open={!!filterAnchorEl}
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <div className={classes.filterPanel}>
          <FormControl>
            <InputLabel>{t('deviceStatus')}</InputLabel>
            <Select
              label={t('deviceStatus')}
              value={filter.statuses}
              onChange={(e) => setFilter({ ...filter, statuses: e.target.value })}
              multiple
            >
              <MenuItem value="online">{`${t('deviceStatusOnline')}`}</MenuItem>
              <MenuItem value="offline">{`${t('deviceStatusOffline')}`}</MenuItem>
              <MenuItem value="unknown">{`${t('deviceStatusUnknown')}`}</MenuItem>
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel>{t('settingsGroups')}</InputLabel>
            <Select
              label={t('settingsGroups')}
              value={filter.groups}
              onChange={(e) => setFilter({ ...filter, groups: e.target.value })}
              multiple
            >
              {Object.values(groups).sort((a, b) => a.name.localeCompare(b.name)).map((group) => (
                <MenuItem key={group.id} value={group.id}>{group.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <InputLabel>{t('sharedSortBy')}</InputLabel>
            <Select
              label={t('sharedSortBy')}
              value={filterSort}
              onChange={(e) => setFilterSort(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">{'\u00a0'}</MenuItem>
              <MenuItem value="name">{t('sharedName')}</MenuItem>
              <MenuItem value="lastUpdate">{t('deviceLastUpdate')}</MenuItem>
            </Select>
          </FormControl>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox checked={filterMap} onChange={(e) => setFilterMap(e.target.checked)} />}
              label={t('sharedFilterMap')}
            />
          </FormGroup>
        </div>
      </Popover>
      <Tooltip title={t('unknownTitle')} arrow>
        <Avatar sx={{ bgcolor: '#ffa000' }} variant="rounded">
          <Typography variant="h5" value="unknown"><font color="#fff" cursor="default">{`${deviceStatusCount('unknown')}`}</font></Typography>
        </Avatar>
      </Tooltip>
      <Tooltip title={t('onlineTitle')} arrow>
        <Avatar sx={{ bgcolor: '#00bd03', width: '55px' }} variant="rounded">
          <Typography variant="h5" value="online"><font color="#fff" cursor="default">{`${deviceStatusCount('online')}`}</font></Typography>
        </Avatar>
      </Tooltip>
      <Tooltip title={t('offlineTitle')} arrow>
        <Avatar sx={{ bgcolor: '#f44336', width: '55px' }} variant="rounded">
          <Typography variant="h5" value="offline"><font color="#fff" cursor="default">{`${deviceStatusCount('offline')}`}</font></Typography>
        </Avatar>
      </Tooltip>
      <Tooltip title={t('totalTitle')} arrow>
        <Avatar sx={{ bgcolor: '#607d8b', width: '55px' }} variant="rounded">
          <Typography variant="h5" value="offline"><font color="#fff" cursor="default">{`${somaStatus}`}</font></Typography>
        </Avatar>
      </Tooltip>
    </Toolbar>
  );
};

export default MainToolbar;
